export const teklifSiparisDurumTypes = {
    TEKLIF: "Teklif",
    SIPARIS: "Siparis"
}